import React from 'react';

export const Modal = ({ title, children, className = '', visible, onClose }) => {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`bg-white rounded shadow max-h-full overflow-y-auto ${className}`} role="dialog" aria-modal="true">
        <div className="flex justify-between items-center border-b p-4">
          <h2 className="text-lg font-medium">{title}</h2>
          <button type="button" onClick={onClose} className="text-xl leading-none">×</button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};
